import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import { View, KeyboardAvoidingView, Platform, useWindowDimensions, ScrollView, Image } from 'react-native';
import { ThemeConsumer } from '@rneui/themed';

import { maxModifierValue, minModifierValue, modifierValue, ModifierData, GetOneProductDetails, ProductFormValues } from '../productModule';
import { config } from '../../../../shared/environment';
import { ZenDropdown, ZenText } from 'zen-core-elements';
import { ItemTypeValue } from 'zen-core-elements/src/elements/zenDropdown/dropdownPicker';
import { FormikProps } from 'formik';

interface modifierProps {
    formik: FormikProps<ProductFormValues>
    editMod: GetOneProductDetails["productDetails"]["productModifiers"],
    setEditMod: Dispatch<SetStateAction<GetOneProductDetails["productDetails"]["productModifiers"]>>,
    multiOptions: string[],
    setMultiOptions: Dispatch<SetStateAction<string[]>>,
    modUpdate: modifierValue[],
    setModUpdate: Dispatch<SetStateAction<modifierValue[]>>,
    optionsMod: ({ defaultOption?: number } & Array<{ id: number, label: string, value: number }>)[],
    setOptionsMod: Dispatch<SetStateAction<({ defaultOption?: number | null } & Array<{ id: number, label: string, value: number }>)[]>>,
    isProductWrite: boolean
    setModValidation: Dispatch<SetStateAction<boolean>>
    modiferDropdownData: ItemTypeValue[]
    selectedModOptObj: ModifierData[],
    setSelectedModOptObj: Dispatch<SetStateAction<ModifierData[]>>
}

// Functional Component to display modifiers
const ProductModifier: FC<modifierProps> = ({ editMod, setEditMod, multiOptions, setMultiOptions, modUpdate, setModUpdate, optionsMod, setOptionsMod, isProductWrite, setModValidation, formik, modiferDropdownData, selectedModOptObj, setSelectedModOptObj }) => {
    // Variable used to store mode, width and height of device
    const { width } = useWindowDimensions()

    //Variable used to store the minModifiers of modifiers
    const [minModifiers, setMinModifiers] = useState<minModifierValue[]>([])
    //Variable used to store the maxModifiers of modifiers
    const [maxModifiers, setMaxModifiers] = useState<maxModifierValue[]>([])
    // Variable used to store option open status
    const [optOpen, setOptOpen] = useState(false)
    //Variable used to store the open state of default option
    const [openState, setOpenState] = useState(true)
    //Variable used to store the multiTextArray
    let multiTextArray: string[]

    //UseEffect used for updating min, max, default objects
    useEffect(() => {
        if (openState) {
            let temp: ({ defaultOption?: number } & Array<{ id: number, label: string, value: number }>)[] = [], minTemp: minModifierValue[] = [], maxTemp: maxModifierValue[] = []
            selectedModOptObj.map((item) => {
                let newArray: { defaultOption?: number } & Array<{ id: number, label: string, value: number }> = [], minArray: { label: string, value: number }[] = []
                let index = -1, minIndex = -1, maxIndex = -1, editIndex = -1

                //Condition for default value check
                if (optionsMod.length > 0) index = optionsMod?.findIndex(ele => ele[0]?.id === item?.id)
                item?.modifierSetMappings?.map((set, i) => {
                    newArray.push({ label: set?.modifier?.optionValue, value: set?.modifier?.id, id: item?.id })
                    minArray?.push({ label: String(i + 1), value: i + 1 })
                })
                if (index != -1 && typeof (optionsMod[index]?.defaultOption) != 'undefined') {
                    newArray.defaultOption = optionsMod[index]?.defaultOption
                }
                if (editMod.length > 0) {
                    editIndex = editMod.findIndex(ele => ele.modifierId === item?.id)
                    if (editIndex != -1) {
                        newArray.defaultOption = editMod[editIndex]?.defaultOptionsId!
                    }
                }
                temp.push(newArray)

                //Condition for minimum option value value check
                if (minModifiers.length > 0) minIndex = minModifiers.findIndex(ele => ele?.id === item?.id)
                if ((minIndex != -1 && minModifiers[minIndex]?.defaultOption != 0) || editIndex != -1) {
                    minTemp.push({ "minSetMappings": [...minArray], "openState": false, "defaultOption": editIndex != -1 ? editMod[editIndex]?.minModifiers : minModifiers[minIndex]?.defaultOption, "id": item?.id })
                } else {
                    minTemp.push({ "minSetMappings": [...minArray], "openState": false, "defaultOption": 0, "id": item?.id })
                }

                //Condition for maximum option value value check
                if (maxModifiers.length > 0) maxIndex = maxModifiers.findIndex(ele => ele?.id === item?.id)
                if ((maxIndex != -1 && maxModifiers[maxIndex]?.defaultOption != 0) || editIndex != -1) {
                    maxTemp.push({ "maxSetMappings": [...minArray], "openState": false, "defaultOption": editIndex != -1 ? editMod[editIndex]?.maxModifiers : maxModifiers[maxIndex]?.defaultOption, "id": item?.id, "maxError": maxModifiers[maxIndex]?.maxError })
                } else {
                    maxTemp.push({ "maxSetMappings": [...minArray], "openState": false, "defaultOption": 0, "id": item?.id, "maxError": false })
                }

            })

            setOptionsMod(temp)
            setMinModifiers(minTemp)
            setMaxModifiers(maxTemp)
            if (minTemp?.length > 0 && editMod?.length > 0) {
                setEditMod([])
            }
        }
    }, [selectedModOptObj])


    //UseEffect used for creating final object structure
    useEffect(() => {
        let finalObject: modifierValue[] = []
        selectedModOptObj.map((item) => {
            let defaultIndex = -1, minIndex = -1, maxIndex = -1
            if (optionsMod.length > 0) defaultIndex = optionsMod.findIndex(ele => ele[0]?.id === item?.id)
            if (minModifiers.length > 0) minIndex = minModifiers.findIndex(ele => ele?.id === item?.id)
            if (maxModifiers.length > 0) maxIndex = maxModifiers.findIndex(ele => ele?.id === item?.id)

            //Final object structure creation
            finalObject.push({
                "storeId": config?.storeId,
                "modifierName": item?.modifierName,
                "defaultOptionsId": (typeof (optionsMod[defaultIndex]?.defaultOption) != 'undefined') ? optionsMod[defaultIndex]?.defaultOption : null,
                "modifierId": item?.id,
                "minModifiers": (minModifiers[minIndex]?.defaultOption && typeof (minModifiers[minIndex]?.defaultOption) != 'undefined') ? minModifiers[minIndex]?.defaultOption : 0,
                "maxModifiers": (maxModifiers[maxIndex]?.defaultOption && typeof (maxModifiers[maxIndex]?.defaultOption) != 'undefined') ? maxModifiers[maxIndex]?.defaultOption : 0
            })
        })

        if (modUpdate.length > 0) {
            setModUpdate([])
        }
        formik.setFieldValue("modifierOption", finalObject)
    }, [minModifiers, maxModifiers, optionsMod])

    //Function used to validate modifier array
    useEffect(() => {
        setModValidation(false)
        maxModifiers.map((item) => {
            if (item?.maxError) {
                setModValidation(true)
            }
        })

    }, [maxModifiers])

    return (
        <ThemeConsumer>
            {({ theme }) => (
                <KeyboardAvoidingView behavior={Platform.OS === "ios" ? "padding" : undefined} style={theme?.addEditProductStyle.flex} enabled
                    onStartShouldSetResponder={() => {
                        setOptOpen(false)
                        setSelectedModOptObj((prevItems) => {
                            let newArray = [...prevItems]
                            newArray.map((i) => {
                                i.defaultOpen = false
                            })
                            return newArray
                        })
                        setMinModifiers((prevItems) => {
                            let newArray = [...prevItems]
                            newArray.map((i) => {
                                i.openState = false
                            })
                            return newArray
                        })
                        setMaxModifiers((prevItems) => {
                            let newArray = [...prevItems]
                            newArray.map((i) => {
                                i.openState = false
                            })
                            return newArray
                        })
                        return false
                    }}
                >
                    <ScrollView style={theme?.addEditProductStyle.flex} showsVerticalScrollIndicator={true}>
                        <View pointerEvents={!isProductWrite ? "box-only" : undefined}>
                            <View style={theme?.addEditProductStyle.modifierVariantHeader}>
                                <ZenText style={[theme?.addEditProductStyle.modifierVariantHeaderText, theme?.addEditProductStyle.mediumText]} color={theme.lightDark} bold content={`Select modifier set for this product`} />
                                {/* modifier dropdown */}
                                <View style={theme?.addEditProductStyle.modifierDropdownView}>
                                    <ZenDropdown
                                        items={modiferDropdownData}
                                        disabled={!isProductWrite}
                                        autoScroll={true}
                                        multiple={true}
                                        closeAfterSelecting={true}
                                        value={formik.values.modifierIds}
                                        setValue={() => { }}
                                        open={optOpen}
                                        setOpen={setOptOpen}
                                        onSelectItem={(selected) => {
                                            setOpenState(true)
                                            formik.setFieldValue("modifierIds", selected.map(item => item.id))
                                            setSelectedModOptObj(selected as ModifierData[])
                                        }}
                                        onChangeValue={(item) => {
                                            let tempArray: string[] = [];
                                            multiTextArray = []
                                            modiferDropdownData?.find((items) => {
                                                item?.find((value) => {
                                                    if (items.value === value) {
                                                        multiTextArray.push(items?.label as string);
                                                        tempArray = multiTextArray?.filter(
                                                            (item, i, newArray) =>
                                                                newArray.indexOf(item) === i,
                                                        );
                                                    }
                                                });
                                            });
                                            setMultiOptions(tempArray);
                                        }}
                                        placeholder="Product modifier set"
                                        multipleText={multiOptions && multiOptions?.length > 2 ? multiOptions?.slice(0, 2).concat('....').toString() : multiOptions?.toString()}
                                        maxHeight={120}
                                        style={theme?.addEditProductStyle.input}
                                        listItemLabelStyle={{
                                            fontSize: theme?.smallerFontSize,
                                        }}
                                        labelStyle={theme?.addEditProductStyle.labelStyle}
                                        containerStyle={theme?.addEditProductStyle.modifierDropdownContainer}
                                        dropDownContainerStyle={theme?.addEditProductStyle.dropDownContainer}
                                        zIndex={5}

                                    />
                                </View>
                            </View>
                            {
                                selectedModOptObj.length == 0 && (
                                    <View style={theme?.addEditProductStyle.emptyStateContainer}>
                                        <Image source={require('../../../../assets/modifiers.png')} style={{ width: width > 900 ? 250 : width > 600 ? 210 : 140, height: width > 900 ? 300 : width > 600 ? 300 : 200, }} />
                                        <ZenText style={theme?.addEditProductStyle.emptyStateText} content={`Currently you have no modifier(s). Please select the modifier(s) from the dropdown list.`} />
                                    </View>
                                )
                            }
                            <View style={[theme?.addEditProductStyle.flex, theme?.addEditProductStyle.marginTop9ZIndexMinus1]}>
                                {selectedModOptObj?.map((item, index) => (
                                    <View key={index} style={theme?.addEditProductStyle.modifierListView}>

                                        <ZenText content={item?.label} bold color={theme.primary} style={theme?.addEditProductStyle.mediumText} />
                                        <View style={theme?.addEditProductStyle.modifierListSubView}>
                                            <ZenText content={'Min, Max options for ' + item?.label} color={theme.lightDark} style={theme?.addEditProductStyle.mediumText} />
                                            <View style={[theme?.addEditProductStyle.modifierListMinMaxSectionView, { columnGap: 10 }]} >
                                                <ZenDropdown
                                                    disabled={!isProductWrite}
                                                    setValue={() => { }}
                                                    items={minModifiers[index]?.minSetMappings}
                                                    value={minModifiers[index]?.defaultOption}
                                                    open={minModifiers[index]?.openState}
                                                    setOpen={() => {
                                                        setOpenState(false)
                                                        setOptOpen(false)
                                                        setMinModifiers((prevItems) => {
                                                            let newArray = [...prevItems]
                                                            newArray[index].openState = !newArray[index].openState
                                                            return newArray
                                                        })
                                                        setSelectedModOptObj((prevItems) => {
                                                            let newArray = [...prevItems]
                                                            newArray[index].defaultOpen = false
                                                            return newArray
                                                        })
                                                        setMaxModifiers((prevItems) => {
                                                            let newArray = [...prevItems]
                                                            newArray[index].openState = false
                                                            return newArray
                                                        })
                                                    }}
                                                    onSelectItem={(selected) => {
                                                        setMinModifiers((prevItems) => {
                                                            let newArray = [...prevItems]
                                                            newArray[index].defaultOption = selected.value as number
                                                            return newArray
                                                        })
                                                        maxModifiers[index]?.defaultOption && setMaxModifiers((prevItems) => {
                                                            let newArray = [...prevItems]
                                                            if (minModifiers[index]?.defaultOption && newArray[index]?.defaultOption && (minModifiers[index]?.defaultOption > newArray[index]?.defaultOption)) {
                                                                newArray[index].maxError = true
                                                            } else {
                                                                newArray[index].maxError = false
                                                            }
                                                            return newArray
                                                        })
                                                    }}

                                                    placeholder="Minimum value"
                                                    multiple={false}
                                                    maxHeight={80}
                                                    style={theme?.addEditProductStyle.input}
                                                    listItemLabelStyle={{
                                                        fontSize: theme?.smallerFontSize,
                                                    }}
                                                    labelStyle={theme?.addEditProductStyle.labelStyle}
                                                    mainContainerStyle={theme?.addEditProductStyle.flex05}
                                                    // dropdownDirection="TOP"
                                                    containerStyle={theme?.addEditProductStyle.marginVertical5}
                                                />
                                                <View
                                                    style={theme?.addEditProductStyle.flex05}
                                                >
                                                    <ZenDropdown
                                                        value={maxModifiers[index]?.defaultOption}
                                                        setValue={() => { }}
                                                        disabled={!isProductWrite}
                                                        items={maxModifiers[index]?.maxSetMappings}
                                                        open={maxModifiers[index]?.openState}
                                                        setOpen={() => {
                                                            setOpenState(false)
                                                            setOptOpen(false)
                                                            setMaxModifiers((prevItems) => {
                                                                let newArray = [...prevItems]
                                                                newArray[index].openState = !newArray[index].openState
                                                                return newArray
                                                            })
                                                            setMinModifiers((prevItems) => {
                                                                let newArray = [...prevItems]
                                                                newArray[index].openState = false
                                                                return newArray
                                                            })
                                                            setSelectedModOptObj((prevItems) => {
                                                                let newArray = [...prevItems]
                                                                newArray[index].defaultOpen = false
                                                                return newArray
                                                            })
                                                        }}
                                                        onSelectItem={(selected) => {
                                                            setMaxModifiers((prevItems) => {
                                                                let newArray = [...prevItems]
                                                                newArray[index].defaultOption = selected.value as number
                                                                if (minModifiers[index]?.defaultOption && (minModifiers[index]?.defaultOption > newArray[index]?.defaultOption)) {
                                                                    newArray[index].maxError = true
                                                                } else {
                                                                    newArray[index].maxError = false
                                                                }
                                                                return newArray
                                                            })
                                                        }}

                                                        placeholder="Maximum value"
                                                        multiple={false}
                                                        maxHeight={80}
                                                        style={theme?.addEditProductStyle.input}
                                                        listItemLabelStyle={{
                                                            fontSize: theme?.smallerFontSize,
                                                        }}
                                                        labelStyle={theme?.addEditProductStyle.labelStyle}
                                                        containerStyle={theme?.addEditProductStyle.marginVertical5}
                                                    />
                                                    {
                                                        maxModifiers[index]?.maxError ? <ZenText content={"Maximum value should exceed minimum value"} size={theme?.errorFontSize} color={"#f44336"} /> : null
                                                    }
                                                </View>
                                            </View>
                                            <View style={theme?.addEditProductStyle.modifierListOptionSectionView}>
                                                <ZenText style={theme?.addEditProductStyle.mediumText} content={'Default option value for ' + item?.label} color={theme.lightDark} />
                                                <ZenDropdown
                                                    open={item?.defaultOpen as boolean}
                                                    disabled={!isProductWrite}
                                                    setOpen={() => {
                                                        setOpenState(false)
                                                        setOptOpen(false)
                                                        setSelectedModOptObj((prevItems) => {
                                                            let newArray = [...prevItems]
                                                            newArray[index].defaultOpen = !newArray[index]?.defaultOpen
                                                            return newArray
                                                        })
                                                        setMinModifiers((prevItems) => {
                                                            let newArray = [...prevItems]
                                                            newArray[index].openState = false
                                                            return newArray
                                                        })
                                                        setMaxModifiers((prevItems) => {
                                                            let newArray = [...prevItems]
                                                            newArray[index].openState = false
                                                            return newArray
                                                        })
                                                    }}
                                                    onSelectItem={(selected) => {
                                                        setOpenState(true)
                                                        setOptionsMod((prevItems) => {
                                                            let newArray = [...prevItems]
                                                            newArray[index].defaultOption = selected?.value as number
                                                            return newArray
                                                        })
                                                    }}
                                                    value={optionsMod[index]?.defaultOption as number}
                                                    items={optionsMod[index]}
                                                    setValue={() => { }}

                                                    style={theme?.addEditProductStyle.input}
                                                    listItemLabelStyle={{
                                                        fontSize: theme?.smallerFontSize,
                                                    }}
                                                    labelStyle={theme?.addEditProductStyle.labelStyle} placeholder="Choose the default option value here"
                                                    multiple={false}
                                                    containerStyle={theme?.addEditProductStyle.marginTop10}
                                                    dropDownContainerStyle={theme?.addEditProductStyle.dropDownContainer}
                                                />
                                            </View>
                                        </View>
                                    </View>
                                ))}
                            </View>
                        </View>
                    </ScrollView>
                </KeyboardAvoidingView>

            )}
        </ThemeConsumer>
    )
}
export default ProductModifier;